export const CAROUSEL_AUTOREFRESH_INTERVAL = 10000; // 10 sec

export const PAGINATOR_SIZE = 5; // items per block
export const MOBILE_PAGINATOR_SIZE = 3;

export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const TIME_FORMAT = 'hh:mm A';

export const SEARCH_DEBOUNCE_TIME = 600;
